(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-tab-block"] && !Shopify.designMode) return;
  try {
    
    class BrandsTab extends HTMLElement {
        constructor() {
            super();
            this.tabTitle = this.querySelector('.tab-title');
            this.tabContent = this.querySelector('.tab-panel-content');
            const ele = this.querySelectorAll('[tab-title-action]');
            const actionLoadMore = this.querySelectorAll('[data-load-more-block]');
            this.widthWindow = 0;
            if (ele.length) {
                ele.forEach((button) => button.addEventListener('click', this.onActive.bind(this)));
            }
            if (actionLoadMore.length) {
                actionLoadMore.forEach((button) => button.addEventListener('click', this.onLoadMore.bind(this)));
            }
        }

        onActive(e) {
            this.tabTitle.querySelector('.active').classList.remove('active');
            this.tabContent.querySelector('.active').classList.remove('active');
            this.querySelector(e.target.dataset.target).classList.add('active');
            e.target.parentElement.classList.add('active');
        }
        onLoadMore(e) {
            this.resize();
            if (this.widthWindow > 1024) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-lg');
                var _number = e.target.dataset.rowlg;
                var _class = 'hidden-lg';
                
            } else if(this.widthWindow > 551) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-md');
                var _number = 9;
                var _class = 'hidden-md';
            } else {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-sm');
                var _number = 6;
                var _class = 'hidden-sm';
            }
            if (eleHide.length) {
                // let number_show = (eleHide.length > number ? number : eleHide.length);
                if (e.target.classList.contains('more')) {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.remove('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonmore;
                    e.target.classList.remove('more');
                } else {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.add('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonless;
                    e.target.classList.add('more');
                }

                // (eleHide.length > _number ? '' : e.target.classList.add('hidden'));
            }
        }
        resize() {
            this.widthWindow = window.innerWidth;
        }
    }
    customElements.define('brand-tab', BrandsTab);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-mobile"]) return;
  try {
    
    class StickyHeaderMobile extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            this.header = document.querySelector('.section-header-mobile');
            this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
            this.headerBounds = {};
    
            if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
            };
    
            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.predictiveSearch = this.querySelector('predictive-search');
    
            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    
            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);
    
            this.createObserver();
        }
  
        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }
  
        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
    
            observer.observe(this.header);
        }
  
        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
            if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    
            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (this.preventHide) return;
                requestAnimationFrame(this.hide.bind(this));
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);
        
                    this.isScrolling = setTimeout(() => {
                    this.preventReveal = false;
                    }, 66);
        
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                this.header.classList.remove('scrolled-past-header');
                requestAnimationFrame(this.reset.bind(this));
            }
    
            this.currentScrollTop = scrollTop;
        }
  
        hide() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            this.header.classList.remove('shopify-section-header-show');
            this.header.style.top = '';
        }
  
        reveal() {
            const headerMultiSite = document.querySelector('.section-header-nav-multi-site');
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            if (headerMultiSite) {
                const height = headerMultiSite.offsetHeight;
                this.header.style.top = `${height}px`;
            }
        }
  
        reset() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
            this.header.style.top = '';
        }
    }
  
    if (!customElements.get('sticky-header-mobile')) {
        customElements.define('sticky-header-mobile', StickyHeaderMobile);
    }

    const mobileMenuToggle = document.querySelector('[data-mobile-menu]');
    if (mobileMenuToggle) {
        mobileMenuToggle.addEventListener('click', (event) => {
            if (window.innerWidth > 1024) {
                event.preventDefault();
                event.stopPropagation();
                if (event.stopImmediatePropagation) event.stopImmediatePropagation();
                document.body.classList.remove('menu_open');
                return;
            }

            document.body.classList.toggle('menu_open');
        });
    }

    (function () {
        if (window.__mobileFlatNestedMenuInit) return;
        window.__mobileFlatNestedMenuInit = true;

        const BREAKPOINT = 1024;
        const STORAGE_KEY = 'mobile_nested_menu_open_state_v21';
        const MENU_PANEL_KEY = 'mobile_menu_panel_open_v1';

        /* 不再记忆“菜单面板已打开”的状态；页面进入时 mobile menu 必须默认关闭。 */
        try {
            localStorage.removeItem(MENU_PANEL_KEY);
        } catch (e) {}

        const SUBMENU_SELECTORS = [
            '.menu-lv__dropdownmenu',
            '.menu-lv__dropdownmenu-1',
            '.menu-lv__dropdownmenu-2',
            '.site-nav-dropdown',
            '.menu-dropdown',
            '.list-menu--disclosure',
            '.dropdown-menu',
            '.submenu',
            '.sub-menu',
            '.site-nav-submenu',
            'ul'
        ];

        function isMobile() {
            return window.innerWidth <= BREAKPOINT;
        }

        function parseJSON(value, fallback) {
            try {
                return JSON.parse(value) || fallback;
            } catch (e) {
                return fallback;
            }
        }

        function getState() {
            return parseJSON(localStorage.getItem(STORAGE_KEY), {});
        }

        function saveState(state) {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
        }

        function directChildren(element) {
            return Array.prototype.slice.call(element.children || []);
        }

        function matchesAny(element, selectors) {
            return selectors.some(function (selector) {
                return element.matches && element.matches(selector);
            });
        }

        function getTrigger(item) {
            const direct = directChildren(item);
            const directTrigger = direct.find(function (child) {
                return child.matches && child.matches('a, button, .menu-lv-1__action, .menu-lv-2__action, .menu-lv-3__action, .site-nav-title');
            });

            if (directTrigger) return directTrigger;

            return Array.prototype.slice.call(item.querySelectorAll('a, button, .menu-lv-1__action, .menu-lv-2__action, .menu-lv-3__action, .site-nav-title')).find(function (candidate) {
                const submenu = candidate.closest('[data-mobile-flat-submenu]');
                return !submenu || submenu.parentElement === item;
            }) || null;
        }

        function getLevel(item) {
            if (item.classList.contains('menu-lv-1')) return 1;
            if (item.classList.contains('menu-lv-2')) return 2;
            if (item.classList.contains('menu-lv-3')) return 3;
            return 0;
        }

        function getDirectSubmenu(item) {
            const children = directChildren(item);
            const trigger = getTrigger(item);
            const targetChildSelector = getLevel(item) === 1 ? '.menu-lv-2' : (getLevel(item) === 2 ? '.menu-lv-3' : '.menu-lv-4');

            let submenu = children.find(function (child) {
                if (child === trigger) return false;
                if (child.matches && child.matches('a, button, .menu-lv-1__action, .menu-lv-2__action, .menu-lv-3__action, .site-nav-title')) return false;
                return matchesAny(child, SUBMENU_SELECTORS);
            });

            if (submenu) return submenu;

            submenu = children.find(function (child) {
                if (child === trigger) return false;
                if (child.matches && child.matches('a, button, .menu-lv-1__action, .menu-lv-2__action, .menu-lv-3__action, .site-nav-title')) return false;
                return !!child.querySelector(targetChildSelector);
            });

            if (submenu) return submenu;

            const descendants = Array.prototype.slice.call(item.querySelectorAll(SUBMENU_SELECTORS.join(',')));
            return descendants.find(function (candidate) {
                const owner = candidate.parentElement ? candidate.parentElement.closest('.menu-lv-1, .menu-lv-2') : null;
                return owner === item && !!candidate.querySelector(targetChildSelector);
            }) || null;
        }

        function getLabel(item) {
            const trigger = getTrigger(item);
            if (!trigger) return '';

            const href = trigger.getAttribute('href') || '';
            const text = trigger.textContent.trim().replace(/\s+/g, ' ');
            return `${href}|${text}`;
        }

        function getItemKey(item) {
            if (item.classList.contains('menu-lv-1')) {
                return `lv1::${getLabel(item)}`;
            }

            if (item.classList.contains('menu-lv-2')) {
                const parentLv1 = item.closest('.menu-lv-1');
                return `lv2::${parentLv1 ? getLabel(parentLv1) : ''}::${getLabel(item)}`;
            }

            return getLabel(item);
        }

        function removeMobileUnderlineMarks() {
            document.querySelectorAll('[data-mobile-flat-trigger]').forEach(function (trigger) {
                trigger.removeAttribute('data-mobile-flat-trigger');
                trigger.removeAttribute('aria-haspopup');
                trigger.removeAttribute('aria-expanded');
            });

            document.querySelectorAll('[data-mobile-flat-has-children]').forEach(function (item) {
                item.removeAttribute('data-mobile-flat-has-children');
            });

            document.querySelectorAll('.mobile-flat-expandable').forEach(function (item) {
                item.classList.remove('mobile-flat-expandable');
            });

            document.querySelectorAll('.mobile-flat-underline-text').forEach(function (item) {
                item.classList.remove('mobile-flat-underline-text');
            });

            document.querySelectorAll('.mobile-flat-underline-self').forEach(function (item) {
                item.classList.remove('mobile-flat-underline-self');
            });
        }

        function hasOwnedChildLevel(item) {
            const level = getLevel(item);
            if (level >= 3) return false;

            const childSelector = level === 1 ? '.menu-lv-2' : '.menu-lv-3';
            const ownerSelector = level === 1 ? '.menu-lv-1' : '.menu-lv-2';

            return Array.prototype.slice.call(item.querySelectorAll(childSelector)).some(function (child) {
                const owner = child.parentElement ? child.parentElement.closest(ownerSelector) : null;
                return owner === item;
            });
        }

        function hasExpandableSignal(item, trigger) {
            if (!item || !trigger) return false;
            if (hasOwnedChildLevel(item)) return true;
            if (getDirectSubmenu(item)) return true;

            return !!(
                trigger.querySelector && trigger.querySelector('.icon-dropdown, .site-nav-arrow, .menu-arrow, .dropdown-icon, [class*="arrow"], [class*="dropdown"]')
            );
        }

        function markTriggerText(trigger) {
            if (!trigger) return;

            let marked = false;
            const childNodes = Array.prototype.slice.call(trigger.childNodes || []);

            childNodes.forEach(function (node) {
                if (node.nodeType === 3 && node.textContent.trim()) {
                    const wrapper = document.createElement('span');
                    wrapper.className = 'mobile-flat-underline-text';
                    node.parentNode.insertBefore(wrapper, node);
                    wrapper.appendChild(node);
                    marked = true;
                    return;
                }

                if (node.nodeType !== 1) return;

                const element = node;
                if (element.matches && element.matches('svg, .icon, .icon-dropdown, .site-nav-arrow, .menu-arrow, .dropdown-icon, [class*="arrow"], [class*="icon"]')) return;
                if (!normalizeText(element)) return;

                element.classList.add('mobile-flat-underline-text');
                marked = true;
            });

            if (!marked) {
                trigger.classList.add('mobile-flat-underline-self');
            }
        }

        function markFlatSubmenus() {
            removeMobileUnderlineMarks();

            document.querySelectorAll('[data-mobile-flat-submenu]').forEach(function (submenu) {
                submenu.removeAttribute('data-mobile-flat-submenu');
            });

            document.querySelectorAll('.menu-lv-1, .menu-lv-2, .menu-lv-3').forEach(function (item) {
                const level = getLevel(item);

                /* 三级菜单是最终层，不做“可展开项”标记，也不会出现下划线。 */
                if (level >= 3) return;

                const submenu = getDirectSubmenu(item);
                const trigger = getTrigger(item);

                if (!trigger) return;
                if (!submenu && !hasExpandableSignal(item, trigger)) return;

                if (submenu) {
                    submenu.setAttribute('data-mobile-flat-submenu', level === 1 ? '2' : '3');
                }

                item.setAttribute('data-mobile-flat-has-children', 'true');
                item.classList.add('mobile-flat-expandable');
                trigger.setAttribute('data-mobile-flat-trigger', level === 1 ? '1' : '2');
                trigger.setAttribute('aria-haspopup', 'true');
                trigger.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
                markTriggerText(trigger);
            });
        }

        function isRealMenuLink(element) {
            return !!(element && (
                element.matches('a[href], button:not([disabled])') ||
                element.closest('a[href], button:not([disabled])')
            ));
        }

        function getTitleHideTarget(element) {
            if (!element) return null;

            const wrapper = element.closest('.nav-title-mobile, .mobile-menu-title, .mobile-menu-heading, .submenu-title, .submenu-heading, .dropdown-title, .dropdown-heading');
            if (wrapper && !wrapper.querySelector('a[href], button:not([disabled]), .menu-lv-1, .menu-lv-2, .menu-lv-3')) {
                return wrapper;
            }

            return element;
        }

        function getMenuItemOwner(element) {
            return element ? element.closest('.menu-lv-1, .menu-lv-2, .menu-lv-3') : null;
        }

        function normalizeText(element) {
            return element ? element.textContent.trim().replace(/\s+/g, ' ') : '';
        }

        function shouldHideTitleNode(candidate, submenu, parentItem) {
            if (!candidate || !submenu || !parentItem) return false;
            if (candidate.classList && candidate.classList.contains('mobile-flat-title-hidden')) return true;

            const owner = getMenuItemOwner(candidate);

            /* 不隐藏真正的二级/三级菜单项内部链接。 */
            if (owner && owner !== parentItem) return false;

            const level = submenu.getAttribute('data-mobile-flat-submenu');
            const parentTrigger = getTrigger(parentItem);
            const parentText = normalizeText(parentTrigger);
            const rootLv1 = parentItem.closest('.menu-lv-1');
            const rootText = normalizeText(rootLv1 ? getTrigger(rootLv1) : null);
            const text = normalizeText(candidate);

            const isDirectChild = candidate.parentElement === submenu;
            const hasMenuItems = !!(candidate.querySelector && candidate.querySelector('.menu-lv-1, .menu-lv-2, .menu-lv-3'));
            const titleLike = candidate.matches && candidate.matches('.nav-title-mobile, .mobile-menu-title, .mobile-menu-heading, .submenu-title, .submenu-heading, .dropdown-title, .dropdown-heading, .site-nav-title, .menu-lv__title, .menu-lv__heading, header, h2, h3');

            if (hasMenuItems) return false;

            /* 三级面板里反复出现的一级标题，例如 Lashes，直接隐藏。 */
            if (level === '3' && isDirectChild && rootText && text === rootText) return true;

            /* 当前二级分类的重复标题也隐藏。 */
            if (isDirectChild && parentText && text && (text === parentText || text.indexOf(parentText) !== -1)) return true;

            /* 常规标题/返回栏隐藏；真实菜单链接已在 owner 判断中保留。 */
            if (titleLike && isDirectChild) return true;

            return false;
        }

        function hideGeneratedTitles() {
            document.querySelectorAll('[data-mobile-flat-submenu]').forEach(function (submenu) {
                const parentItem = submenu.parentElement ? submenu.parentElement.closest('.menu-lv-1, .menu-lv-2') : null;
                if (!parentItem) return;

                submenu.querySelectorAll('.nav-title-mobile, .mobile-menu-title, .mobile-menu-heading, .submenu-title, .submenu-heading, .dropdown-title, .dropdown-heading, .site-nav-title, .menu-lv__title, .menu-lv__heading, header, h2, h3').forEach(function (candidate) {
                    if (!shouldHideTitleNode(candidate, submenu, parentItem)) return;

                    candidate.classList.add('mobile-flat-title-hidden');
                    candidate.setAttribute('aria-hidden', 'true');
                });

                directChildren(submenu).forEach(function (child) {
                    if (!shouldHideTitleNode(child, submenu, parentItem)) return;

                    child.classList.add('mobile-flat-title-hidden');
                    child.setAttribute('aria-hidden', 'true');
                });
            });
        }

        function getSubmenuFullHeight(submenu) {
            if (!submenu) return 0;

            let height = submenu.scrollHeight || 0;

            Array.prototype.slice.call(submenu.children || []).forEach(function (child) {
                if (!child.classList || child.classList.contains('mobile-flat-title-hidden')) return;
                const rectHeight = child.getBoundingClientRect ? child.getBoundingClientRect().height : 0;
                const offsetHeight = child.offsetHeight || 0;
                height += Math.max(rectHeight, offsetHeight, 0);
            });

            return height;
        }

        function setSubmenuHeight(item) {
            const submenu = getDirectSubmenu(item);
            if (!submenu) return;

            /*
                用足够大的 max-height 兜底，避免三级菜单底部被二级/一级容器裁切。
                关闭状态仍由 max-height: 0 控制；打开状态保持平铺完整显示。
            */
            const dynamicHeight = getSubmenuFullHeight(submenu);
            const buffer = item.classList.contains('menu-lv-1') ? 1800 : 1200;
            const finalHeight = Math.max(dynamicHeight + buffer, 9999);

            submenu.style.setProperty('--mobile-flat-submenu-height', `${finalHeight}px`);
        }

        function updateOpenAncestorHeights(item) {
            let parent = item.parentElement ? item.parentElement.closest('.menu-lv-1.is-open, .menu-lv-2.is-open') : null;

            while (parent) {
                setSubmenuHeight(parent);
                parent = parent.parentElement ? parent.parentElement.closest('.menu-lv-1.is-open, .menu-lv-2.is-open') : null;
            }
        }

        function syncOpenSubmenuHeights() {
            const openItems = Array.prototype.slice.call(document.querySelectorAll('.menu-lv-1.is-open, .menu-lv-2.is-open'));

            openItems.sort(function (a, b) {
                return b.querySelectorAll('.menu-lv-1, .menu-lv-2').length - a.querySelectorAll('.menu-lv-1, .menu-lv-2').length;
            }).forEach(function (item) {
                setSubmenuHeight(item);
            });
        }

        function scheduleHeightSync(item) {
            const run = function () {
                setSubmenuHeight(item);
                updateOpenAncestorHeights(item);
                syncOpenSubmenuHeights();
            };

            requestAnimationFrame(function () {
                run();
                requestAnimationFrame(run);
            });

            window.setTimeout(run, 90);
            window.setTimeout(run, 220);
            window.setTimeout(run, 380);
            window.setTimeout(run, 520);
            window.setTimeout(run, 760);
            window.setTimeout(run, 1000);
        }

        function setOpen(item, open) {
            const submenu = getDirectSubmenu(item);
            const trigger = getTrigger(item);

            if (!submenu) return;

            hideGeneratedTitles();
            setSubmenuHeight(item);

            if (open) {
                item.classList.add('is-open');
                if (trigger) trigger.setAttribute('aria-expanded', 'true');
                scheduleHeightSync(item);
            } else {
                item.classList.remove('is-open');
                if (trigger) trigger.setAttribute('aria-expanded', 'false');
                scheduleHeightSync(item);
            }
        }

        function closeChildren(item, state) {
            item.querySelectorAll('.menu-lv-1.is-open, .menu-lv-2.is-open').forEach(function (child) {
                if (child === item) return;
                setOpen(child, false);
                state[getItemKey(child)] = false;
            });
        }

        function restoreMenuState() {
            markFlatSubmenus();
            hideGeneratedTitles();

            if (!isMobile()) {
                document.body.classList.remove('menu_open');
                return;
            }

            const state = getState();

            document.querySelectorAll('.menu-lv-1, .menu-lv-2, .menu-lv-3').forEach(function (item) {
                if (!getDirectSubmenu(item)) return;
                setOpen(item, !!state[getItemKey(item)]);
            });

            /* 页面初始加载时不自动打开 mobile menu。菜单只允许由汉堡按钮点击打开。 */
            try {
                localStorage.removeItem(MENU_PANEL_KEY);
            } catch (e) {}
            document.body.classList.remove('menu_open');

            requestAnimationFrame(syncOpenSubmenuHeights);
        }

        function findToggleItemFromEvent(event) {
            const target = event.target;
            if (!target || !target.closest) return null;

            /*
                三级菜单里的真实链接必须保持跳转，不允许冒泡成“收起二级”。
                之前不能收起的核心原因是：旧逻辑先判断 submenu.contains(target)，
                在 Halo 的部分结构里，二级 trigger 会被自己的三级容器或父级平铺容器包住，
                结果再次点击二级栏目时被误判成“点击了子菜单内容”。
            */
            if (target.closest('.menu-lv-3')) return null;

            const action = target.closest('a, button, .menu-lv-1__action, .menu-lv-2__action, .menu-lv-3__action, .site-nav-title');
            if (!action) return null;

            function isOwnTopAction(item, trigger) {
                if (!item) return false;

                const actionOwner = action.closest('.menu-lv-2, .menu-lv-1');
                if (actionOwner !== item) return false;

                /*
                    只要点击的是当前菜单项自己的二级/一级栏目，就允许切换。
                    这里不要再用 submenu.contains(target) 排除，因为二级栏目可能在主题结构里
                    被父级平铺容器包住。三级真实链接已经在函数开头通过 .menu-lv-3 排除了。
                */
                if (!trigger) return true;
                if (trigger === action) return true;
                if (trigger.contains && trigger.contains(target)) return true;
                if (action.contains && action.contains(trigger)) return true;
                if (action.parentElement === item) return true;

                const directTrigger = Array.prototype.slice.call(item.children || []).find(function (child) {
                    return child.matches && child.matches('a, button, .menu-lv-1__action, .menu-lv-2__action, .menu-lv-3__action, .site-nav-title');
                });

                if (directTrigger === action) return true;
                if (directTrigger && directTrigger.contains && directTrigger.contains(target)) return true;

                /*
                    兜底：Halo 主题有时会把栏目文字包在额外 wrapper 里，只要最近的
                    .menu-lv-2 / .menu-lv-1 是当前 item，就按当前 item 的栏目点击处理。
                */
                return true;
            }

            /*
                优先处理最近的二级菜单项。这样点击 Premade Fans 这类二级栏目时，
                会切换它自己的三级菜单，而不是被父级 Lashes 抢走。
            */
            const nearestLv2 = target.closest('.menu-lv-2');
            if (nearestLv2) {
                const submenu = getDirectSubmenu(nearestLv2);
                const trigger = getTrigger(nearestLv2);

                if (submenu && isOwnTopAction(nearestLv2, trigger)) {
                    return nearestLv2;
                }
            }

            const nearestLv1 = target.closest('.menu-lv-1');
            if (nearestLv1) {
                const submenu = getDirectSubmenu(nearestLv1);
                const trigger = getTrigger(nearestLv1);

                if (submenu && isOwnTopAction(nearestLv1, trigger)) {
                    return nearestLv1;
                }
            }

            return null;
        }

        document.addEventListener('click', function (event) {
            if (!isMobile()) return;

            const item = findToggleItemFromEvent(event);
            if (!item) return;

            const submenu = getDirectSubmenu(item);
            if (!submenu) return;

            event.preventDefault();
            event.stopPropagation();
            if (event.stopImmediatePropagation) event.stopImmediatePropagation();

            const state = getState();
            const willOpen = !item.classList.contains('is-open');

            setOpen(item, willOpen);
            state[getItemKey(item)] = willOpen;

            if (!willOpen) {
                closeChildren(item, state);
            }

            saveState(state);
        }, true);

        document.addEventListener('click', function (event) {
            const button = event.target.closest('[data-mobile-menu]');
            if (!button) return;

            setTimeout(function () {
                /* 只在当前页面打开/关闭，不把打开状态带到下一次访问。 */
                try {
                    localStorage.removeItem(MENU_PANEL_KEY);
                } catch (e) {}

                if (document.body.classList.contains('menu_open')) {
                    markFlatSubmenus();
                    hideGeneratedTitles();
                    syncOpenSubmenuHeights();
                }
            }, 0);
        });

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', restoreMenuState);
        } else {
            restoreMenuState();
        }

        document.addEventListener('shopify:section:load', restoreMenuState);

        window.addEventListener('resize', function () {
            if (!isMobile()) {
                document.body.classList.remove('menu_open');
                return;
            }

            markFlatSubmenus();
            syncOpenSubmenuHeights();
        });
    })();

    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        const expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    };

    function renderLogoMobile() {
        if ($("[data-menu-tab]").length > 0) {

            $(document).on("click", "[data-menu-tab] li", (event) => {
                var active = $(event.currentTarget).data("load-page"),
                    href = $(event.currentTarget).attr("href");

                $.cookie("page-url", active, {
                    expires: 1,
                    path: "/",
                });
            });

            var canonical = $("[canonical-shop-url]").attr("canonical-shop-url"),
            pageUrl = $.cookie("page-url"),
            menuTabItem,
            logoTabItem,
            menuItem;

            if (
                window.location.pathname.indexOf("/pages/") !== -1 &&
                window.page_active &&
                window.page_active != pageUrl
            ) {
                setCookie("page-url", window.page_active, 1);
                pageUrl = window.page_active;
            }
            
            if (pageUrl != null) {
                menuTabItem = $(`[data-load-page="${pageUrl}"]`);
                logoTabItem = $(`[data-load-logo-page="${pageUrl}"]`);
                menuItem = $(`[data-load-menu-page="${pageUrl}"]`);
            } else {
                menuTabItem = $("[data-load-page].is-active");
                logoTabItem = $("[data-load-logo-page].first");
                menuItem = $("[data-load-menu-page].is-active");
            }

            var menuTab = menuTabItem.closest("[data-menu-tab]");

            menuTab
                .find("[data-load-page]")
                .not(menuTabItem)
                .removeClass("is-active");
                logoTabItem.siblings().removeClass("is-active");
                menuItem.siblings().removeClass("is-active");
            if (pageUrl != "") {
                logoTabItem.addClass("is-active");
                menuTabItem.addClass("is-active");
                menuItem.addClass("is-active");
            } else {
                $("[data-load-page]:nth-child(1)").addClass("is-active");
                $("[data-load-logo-page]:nth-child(1)").addClass("is-active");
                $("[data-load-menu-page]:nth-child(1)").addClass("is-active");
            }

            const header = menuTabItem.closest(".header");

            
            if (header && window.innerWidth < 1025) {
                if (
                    window.location.pathname.indexOf("/pages/") !== -1 &&
                    window.page_active &&
                    window.page_active != pageUrl
                ) {
                    setCookie("page-url", window.page_active, 1);
                    pageUrl = window.page_active;
                }

                const logoMobile = $(".header-mobile .header__heading-link");
                const logDesktop = header.find(".header__heading-link.is-active");

                if (logDesktop.data("logo-mobile") == undefined) {
                    logoMobile.find("img").addClass("logo-show");
                    return;
                } else {
                    logoMobile.html(
                    `<img src="${logDesktop.data(
                        "logo-mobile"
                    )}" alt="${logDesktop.data(
                        "logo-mobile-alt"
                    )}" style="max-width: ${logoMobile.data(
                        "logo-width"
                    )}px; height: auto"/>`
                    );

                    logoMobile.find("img").addClass("logo-show");
                    if (pageUrl != "" && pageUrl != null)
                    logoMobile.attr("href", pageUrl);
                }
            }
        }
    }


    (function () {
        if (window.__mobileMenuTabsUseOriginalRootInit) return;
        window.__mobileMenuTabsUseOriginalRootInit = true;

        const BREAKPOINT = 1024;
        const ACTIVE_TAB_KEY = 'mobile_menu_tabs_active_v3';

        function isMobileTabsView() {
            return window.innerWidth <= BREAKPOINT;
        }

        function isMobileMenuOpen() {
            return document.body.classList.contains('menu_open');
        }

        function enforceMobileTabsDesktopClosed() {
            if (isMobileTabsView()) return;

            document.body.classList.remove('menu_open');

            document.querySelectorAll('[data-mobile-menu-tabs-bar], [data-mobile-menu-tabs-helper]').forEach(function (element) {
                element.remove();
            });

            document.querySelectorAll('[data-mobile-menu-tabs-root]').forEach(function (root) {
                const originalHTML = root.getAttribute('data-mobile-menu-tabs-original-html');
                if (originalHTML !== null) {
                    root.innerHTML = originalHTML;
                }
                root.removeAttribute('data-mobile-menu-tabs-root');
            });
        }

        function getTabsSource() {
            return document.querySelector('[data-mobile-menu-tabs-source]');
        }

        function directChildren(element) {
            return Array.prototype.slice.call(element ? element.children || [] : []);
        }

        function hasDirectLevelOne(element) {
            return directChildren(element).some(function (child) {
                return child.classList && child.classList.contains('menu-lv-1');
            });
        }

        function isInsideTabsFeature(element) {
            return !!(element && element.closest && element.closest('[data-mobile-menu-tabs-source], [data-mobile-menu-tabs-bar]'));
        }

        function isMobileMenuRootCandidate(element) {
            if (!element || !element.closest) return false;

            const mobileOwner = element.closest('.halo-sidebar, .halo-sidebar_menu, .halo-sidebar-wrapper, .halo-sidebar__content, .menu-drawer, .menu-mobile, .nav-menu-mobile, .site-nav-mobile, .mobile-menu');
            if (!mobileOwner) return false;

            const desktopHeader = element.closest('.header:not(.header-mobile)');
            if (desktopHeader && !element.closest('.header-mobile')) return false;

            return true;
        }

        function findOriginalMenuRoot() {
            const selectors = [
                'body.menu_open [data-load-menu-page].is-active > .site-nav-list',
                'body.menu_open [data-load-menu-page].is-active > .list-menu',
                'body.menu_open [data-load-menu-page].is-active .site-nav-list',
                'body.menu_open [data-load-menu-page].is-active .list-menu',
                'body.menu_open .site-nav-mobile > .site-nav-list',
                'body.menu_open .site-nav-mobile > .list-menu',
                'body.menu_open .nav-menu-mobile > .site-nav-list',
                'body.menu_open .nav-menu-mobile > .list-menu',
                'body.menu_open .menu-mobile > .site-nav-list',
                'body.menu_open .menu-mobile > .list-menu',
                'body.menu_open .menu-drawer .site-nav-list',
                'body.menu_open .menu-drawer .list-menu',
                'body.menu_open .halo-sidebar_menu .site-nav-list',
                'body.menu_open .halo-sidebar_menu .list-menu',
                'body.menu_open .halo-sidebar .site-nav-list',
                'body.menu_open .halo-sidebar .list-menu',
                '[data-load-menu-page].is-active > .site-nav-list',
                '[data-load-menu-page].is-active > .list-menu',
                '[data-load-menu-page].is-active .site-nav-list',
                '[data-load-menu-page].is-active .list-menu',
                '.site-nav-mobile > .site-nav-list',
                '.site-nav-mobile > .list-menu',
                '.nav-menu-mobile > .site-nav-list',
                '.nav-menu-mobile > .list-menu',
                '.menu-mobile > .site-nav-list',
                '.menu-mobile > .list-menu',
                '.menu-drawer .site-nav-list',
                '.menu-drawer .list-menu',
                '.halo-sidebar_menu .site-nav-list',
                '.halo-sidebar_menu .list-menu',
                '.halo-sidebar .site-nav-list',
                '.halo-sidebar .list-menu'
            ];

            for (let i = 0; i < selectors.length; i++) {
                const matches = Array.prototype.slice.call(document.querySelectorAll(selectors[i]));
                for (let j = 0; j < matches.length; j++) {
                    const candidate = matches[j];
                    if (!candidate || isInsideTabsFeature(candidate)) continue;
                    if (!isMobileMenuRootCandidate(candidate)) continue;
                    if (candidate.closest && candidate.closest('[data-mobile-flat-submenu]')) continue;
                    if (hasDirectLevelOne(candidate)) return candidate;
                }
            }

            const levelOne = Array.prototype.slice.call(document.querySelectorAll('body.menu_open .menu-lv-1, .menu-lv-1')).find(function (item) {
                return item && !isInsideTabsFeature(item) && isMobileMenuRootCandidate(item) && !(item.closest && item.closest('[data-mobile-flat-submenu]'));
            });

            return levelOne ? levelOne.parentElement : null;
        }

        function getSourceButtons() {
            const source = getTabsSource();
            return source ? Array.prototype.slice.call(source.querySelectorAll('[data-mobile-menu-tab-button]')) : [];
        }

        function getFirstTabIndex() {
            const firstButton = getSourceButtons()[0];
            return firstButton ? firstButton.getAttribute('data-mobile-menu-tab-index') : '';
        }

        function getStoredTabIndex() {
            const stored = localStorage.getItem(ACTIVE_TAB_KEY);
            const exists = getSourceButtons().some(function (button) {
                return button.getAttribute('data-mobile-menu-tab-index') === stored;
            });

            return exists ? stored : getFirstTabIndex();
        }

        function setButtonState(index) {
            document.querySelectorAll('[data-mobile-menu-tabs-bar] [data-mobile-menu-tab-button]').forEach(function (button) {
                const active = button.getAttribute('data-mobile-menu-tab-index') === index;
                button.classList.toggle('is-active', active);
                button.setAttribute('aria-selected', active ? 'true' : 'false');
            });
        }

        function ensureTabsBar(root) {
            const source = getTabsSource();
            if (!source || !root || !root.parentElement) return null;

            const parent = root.parentElement;
            let bar = directChildren(parent).find(function (child) {
                return child.hasAttribute && child.hasAttribute('data-mobile-menu-tabs-bar');
            });

            if (!bar) {
                const templateBar = source.querySelector('[data-mobile-menu-tabs-bar-template]');
                if (!templateBar) return null;

                bar = templateBar.cloneNode(true);
                bar.removeAttribute('data-mobile-menu-tabs-bar-template');
                bar.setAttribute('data-mobile-menu-tabs-bar', '');
                bar.removeAttribute('hidden');
                bar.style.cssText = source.getAttribute('style') || '';
                parent.insertBefore(bar, root);
            }

            let helper = directChildren(parent).find(function (child) {
                return child.hasAttribute && child.hasAttribute('data-mobile-menu-tabs-helper');
            });

            if (!helper) {
                const templateHelper = source.querySelector('[data-mobile-menu-tabs-helper-template]');

                if (templateHelper) {
                    helper = templateHelper.cloneNode(true);
                    helper.removeAttribute('data-mobile-menu-tabs-helper-template');
                    helper.setAttribute('data-mobile-menu-tabs-helper', '');
                    helper.removeAttribute('hidden');
                    parent.insertBefore(helper, root);
                }
            }

            if (helper && bar && helper.previousElementSibling !== bar) {
                parent.insertBefore(helper, bar.nextSibling);
            }

            return bar;
        }

        function storeOriginalMenu(root) {
            if (!root || root.hasAttribute('data-mobile-menu-tabs-original-html')) return;
            root.setAttribute('data-mobile-menu-tabs-original-html', root.innerHTML);
        }

        function clearOpenState(root) {
            if (!root) return;

            root.querySelectorAll('.is-open').forEach(function (item) {
                item.classList.remove('is-open');
            });

            root.querySelectorAll('[aria-expanded="true"]').forEach(function (item) {
                item.setAttribute('aria-expanded', 'false');
            });
        }

        function refreshNestedMenuMarkers() {
            requestAnimationFrame(function () {
                window.dispatchEvent(new Event('resize'));
                setTimeout(function () {
                    window.dispatchEvent(new Event('resize'));
                }, 80);
                setTimeout(function () {
                    window.dispatchEvent(new Event('resize'));
                }, 240);
            });
        }

        function applyTab(index) {
            const source = getTabsSource();
            if (!source || !isMobileTabsView()) return false;

            const root = findOriginalMenuRoot();
            if (!root) return false;

            storeOriginalMenu(root);
            ensureTabsBar(root);

            const template = source.querySelector('[data-mobile-menu-tab-template][data-mobile-menu-tab-index="' + index + '"]');
            if (!template) return false;

            root.innerHTML = template.innerHTML;
            root.setAttribute('data-mobile-menu-tabs-root', '');
            clearOpenState(root);
            setButtonState(index);
            localStorage.setItem(ACTIVE_TAB_KEY, index);
            refreshNestedMenuMarkers();

            return true;
        }

        function initMobileMenuTabs() {
            if (!isMobileTabsView()) {
                enforceMobileTabsDesktopClosed();
                return;
            }

            const source = getTabsSource();
            if (!source || !isMobileMenuOpen()) return;

            const root = findOriginalMenuRoot();
            if (!root) return;

            storeOriginalMenu(root);
            ensureTabsBar(root);
            applyTab(getStoredTabIndex());
        }

        document.addEventListener('click', function (event) {
            const button = event.target.closest('[data-mobile-menu-tabs-bar] [data-mobile-menu-tab-button]');
            if (!button) return;

            event.preventDefault();
            event.stopPropagation();
            if (event.stopImmediatePropagation) event.stopImmediatePropagation();

            applyTab(button.getAttribute('data-mobile-menu-tab-index'));
        }, true);

        document.addEventListener('click', function (event) {
            const button = event.target.closest('[data-mobile-menu]');
            if (!button) return;

            if (!isMobileTabsView()) {
                enforceMobileTabsDesktopClosed();
                return;
            }

            setTimeout(initMobileMenuTabs, 40);
            setTimeout(initMobileMenuTabs, 180);
            setTimeout(initMobileMenuTabs, 420);
        });

        function closeMenuOnInitialLoad() {
            document.body.classList.remove('menu_open');
            try {
                localStorage.removeItem('mobile_menu_panel_open_v1');
            } catch (e) {}
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function () {
                closeMenuOnInitialLoad();
                initMobileMenuTabs();
            });
        } else {
            closeMenuOnInitialLoad();
            initMobileMenuTabs();
        }

        document.addEventListener('shopify:section:load', initMobileMenuTabs);

        window.addEventListener('resize', function (event) {
            if (event && event.isTrusted === false) return;

            if (!isMobileTabsView()) {
                enforceMobileTabsDesktopClosed();
                return;
            }

            if (isMobileMenuOpen()) {
                initMobileMenuTabs();
            }
        });
    })();


    renderLogoMobile();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-multi-site-speculationrules"] && !Shopify.designMode) return;
  try {
    
(function () {
    function initStickyHeader(scope) {
        var wrappers = (scope || document).querySelectorAll('[data-halo-sticky-header]');

        wrappers.forEach(function (wrapper) {
            if (wrapper.dataset.haloStickyReady === 'true') return;
            wrapper.dataset.haloStickyReady = 'true';

            var section = wrapper.closest('.section-header-navigation');
            if (!section) return;

            var stickyType = wrapper.getAttribute('data-sticky-type') || 'none';
            var placeholder = document.createElement('div');
            placeholder.className = 'halo-sticky-placeholder';
            placeholder.setAttribute('aria-hidden', 'true');
            wrapper.parentNode.insertBefore(placeholder, wrapper.nextSibling);

            var triggerTop = 0;
            var headerHeight = 0;
            var ticking = false;

            function getScrollTop() {
                return window.pageYOffset || document.documentElement.scrollTop || 0;
            }

            function isSticky() {
                return section.classList.contains('shopify-section-header-sticky');
            }

            function measure() {
                headerHeight = wrapper.offsetHeight || 0;

                if (isSticky() && placeholder.classList.contains('is-active')) {
                    triggerTop = placeholder.getBoundingClientRect().top + getScrollTop();
                } else {
                    triggerTop = wrapper.getBoundingClientRect().top + getScrollTop();
                }

                document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
            }

            function setSticky(active) {
                if (stickyType === 'none') return;

                if (active) {
                    headerHeight = wrapper.offsetHeight || headerHeight;
                    placeholder.style.height = headerHeight + 'px';
                    placeholder.classList.add('is-active');
                    section.classList.add('shopify-section-header-sticky', 'scrolled-past-header');
                    section.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show');
                    wrapper.classList.add('is-sticky');
                    document.body.classList.add('scrolled-header');
                } else {
                    section.classList.remove('shopify-section-header-sticky', 'shopify-section-header-hidden', 'shopify-section-header-show', 'animate', 'scrolled-past-header');
                    wrapper.classList.remove('is-sticky');
                    placeholder.classList.remove('is-active');
                    placeholder.style.height = '0px';
                    document.body.classList.remove('scrolled-header');
                }
            }

            function update() {
                ticking = false;

                if (stickyType === 'always') {
                    if (!isSticky()) measure();
                    setSticky(true);
                    return;
                }

                if (stickyType === 'on_scroll') {
                    var shouldStick = getScrollTop() > triggerTop;
                    setSticky(shouldStick);
                }
            }

            function requestUpdate() {
                if (ticking) return;
                ticking = true;
                window.requestAnimationFrame(update);
            }

            function refresh() {
                var active = isSticky();
                if (active) setSticky(false);
                measure();
                update();
            }

            measure();
            update();

            window.addEventListener('scroll', requestUpdate, { passive: true });
            window.addEventListener('resize', refresh);
            window.addEventListener('load', refresh);

            if (window.ResizeObserver) {
                var resizeObserver = new ResizeObserver(function () {
                    if (isSticky()) {
                        headerHeight = wrapper.offsetHeight || headerHeight;
                        placeholder.style.height = headerHeight + 'px';
                        document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
                    } else {
                        refresh();
                    }
                });
                resizeObserver.observe(wrapper);
            }
        });
    }

    initStickyHeader(document);

    document.addEventListener('DOMContentLoaded', function () {
        initStickyHeader(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
        initStickyHeader(event.target);
    });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-multi-site-tab-menu-short"] && !Shopify.designMode) return;
  try {
    
(function () {
    var stickyRoot = document.querySelector('sticky-header');
    var sticky = stickyRoot ? stickyRoot.querySelector('.header-nav-multi-site') : null;

    if (!sticky || customElements.get('sticky-header')) return;

    class StickyHeader extends HTMLElement {
        constructor() { super(); }

        connectedCallback() {
            this.header = document.querySelector('.section-header-navigation');
            this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
            this.headerBounds = {};
            this.setHeaderHeight();
            window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

            if (this.headerIsAlwaysSticky) {
                this.header.classList.add('shopify-section-header-sticky');
            }

            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.predictiveSearch = this.querySelector('predictive-search');
            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;
            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);
            this.createObserver();
        }

        setHeaderHeight() {
            if (this.header) document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            if (!this.header) return;
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
            observer.observe(this.header);
        }

        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                if (this.preventHide) return;
                this.header.classList.add('scrolled-past-header');
                requestAnimationFrame(this.hide.bind(this));
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);
                    this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                this.header.classList.remove('scrolled-past-header');
                requestAnimationFrame(this.reset.bind(this));
            }
            this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return;
                }
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
            this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return;
                }
                this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                this.header.classList.remove('shopify-section-header-hidden');
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return;
                }
                this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
            }
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-multi-site-tab-menu-v3"] && !Shopify.designMode) return;
  try {
    
(function () {
    function initStickyHeader(scope) {
        var wrappers = (scope || document).querySelectorAll('[data-halo-sticky-header]');

        wrappers.forEach(function (wrapper) {
            if (wrapper.dataset.haloStickyReady === 'true') return;
            wrapper.dataset.haloStickyReady = 'true';

            var section = wrapper.closest('.section-header-navigation');
            if (!section) return;

            var stickyType = wrapper.getAttribute('data-sticky-type') || 'none';
            var placeholder = document.createElement('div');
            placeholder.className = 'halo-sticky-placeholder';
            placeholder.setAttribute('aria-hidden', 'true');
            wrapper.parentNode.insertBefore(placeholder, wrapper.nextSibling);

            var triggerTop = 0;
            var headerHeight = 0;
            var ticking = false;

            function getScrollTop() {
                return window.pageYOffset || document.documentElement.scrollTop || 0;
            }

            function isSticky() {
                return section.classList.contains('shopify-section-header-sticky');
            }

            function measure() {
                headerHeight = wrapper.offsetHeight || 0;

                if (isSticky() && placeholder.classList.contains('is-active')) {
                    triggerTop = placeholder.getBoundingClientRect().top + getScrollTop();
                } else {
                    triggerTop = wrapper.getBoundingClientRect().top + getScrollTop();
                }

                document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
            }

            function setSticky(active) {
                if (stickyType === 'none') return;

                if (active) {
                    headerHeight = wrapper.offsetHeight || headerHeight;
                    placeholder.style.height = headerHeight + 'px';
                    placeholder.classList.add('is-active');
                    section.classList.add('shopify-section-header-sticky', 'scrolled-past-header');
                    section.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show');
                    wrapper.classList.add('is-sticky');
                    document.body.classList.add('scrolled-header');
                } else {
                    section.classList.remove('shopify-section-header-sticky', 'shopify-section-header-hidden', 'shopify-section-header-show', 'animate', 'scrolled-past-header');
                    wrapper.classList.remove('is-sticky');
                    placeholder.classList.remove('is-active');
                    placeholder.style.height = '0px';
                    document.body.classList.remove('scrolled-header');
                }
            }

            function update() {
                ticking = false;

                if (stickyType === 'always') {
                    if (!isSticky()) measure();
                    setSticky(true);
                    return;
                }

                if (stickyType === 'on_scroll') {
                    var shouldStick = getScrollTop() > triggerTop;
                    setSticky(shouldStick);
                }
            }

            function requestUpdate() {
                if (ticking) return;
                ticking = true;
                window.requestAnimationFrame(update);
            }

            function refresh() {
                var active = isSticky();
                if (active) setSticky(false);
                measure();
                update();
            }

            measure();
            update();

            window.addEventListener('scroll', requestUpdate, { passive: true });
            window.addEventListener('resize', refresh);
            window.addEventListener('load', refresh);

            if (window.ResizeObserver) {
                var resizeObserver = new ResizeObserver(function () {
                    if (isSticky()) {
                        headerHeight = wrapper.offsetHeight || headerHeight;
                        placeholder.style.height = headerHeight + 'px';
                        document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
                    } else {
                        refresh();
                    }
                });
                resizeObserver.observe(wrapper);
            }
        });
    }

    initStickyHeader(document);

    document.addEventListener('DOMContentLoaded', function () {
        initStickyHeader(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
        initStickyHeader(event.target);
    });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-multi-site-wave-search-speculationrules"] && !Shopify.designMode) return;
  try {
    
(function () {
    var MOBILE_STICKY_QUERY = '(max-width: 1024px)';

    function initStickyHeader(scope) {
        var wrappers = (scope || document).querySelectorAll('[data-halo-sticky-header]');

        wrappers.forEach(function (wrapper) {
            if (wrapper.dataset.haloStickyReady === 'true') return;
            wrapper.dataset.haloStickyReady = 'true';

            var section = wrapper.closest('.section-header-navigation');
            if (!section) return;

            var stickyType = wrapper.getAttribute('data-sticky-type') || 'none';
            var mobileStickyMedia = window.matchMedia(MOBILE_STICKY_QUERY);
            var placeholder = document.createElement('div');
            var triggerTop = 0;
            var headerHeight = 0;
            var ticking = false;

            placeholder.className = 'halo-sticky-placeholder';
            placeholder.setAttribute('aria-hidden', 'true');
            wrapper.parentNode.insertBefore(placeholder, wrapper.nextSibling);

            function isMobileStickyDisabled() {
                return mobileStickyMedia.matches;
            }

            function getScrollTop() {
                return window.pageYOffset || document.documentElement.scrollTop || 0;
            }

            function isSticky() {
                return section.classList.contains('shopify-section-header-sticky');
            }

            function clearStickyState() {
                section.classList.remove('shopify-section-header-sticky', 'shopify-section-header-hidden', 'shopify-section-header-show', 'animate', 'scrolled-past-header');
                wrapper.classList.remove('is-sticky');
                placeholder.classList.remove('is-active');
                placeholder.style.height = '0px';
                document.body.classList.remove('scrolled-header');
            }

            function measure() {
                headerHeight = wrapper.offsetHeight || 0;

                if (isSticky() && placeholder.classList.contains('is-active')) {
                    triggerTop = placeholder.getBoundingClientRect().top + getScrollTop();
                } else {
                    triggerTop = wrapper.getBoundingClientRect().top + getScrollTop();
                }

                document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
            }

            function setSticky(active) {
                if (stickyType === 'none' || isMobileStickyDisabled()) {
                    active = false;
                }

                if (!active) {
                    if (!isSticky() && !wrapper.classList.contains('is-sticky') && !placeholder.classList.contains('is-active')) {
                        return;
                    }
                    clearStickyState();
                    return;
                }

                headerHeight = wrapper.offsetHeight || headerHeight;
                placeholder.style.height = headerHeight + 'px';

                if (isSticky() && wrapper.classList.contains('is-sticky') && placeholder.classList.contains('is-active')) {
                    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
                    return;
                }

                placeholder.classList.add('is-active');
                section.classList.add('shopify-section-header-sticky', 'scrolled-past-header');
                section.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show');
                wrapper.classList.add('is-sticky');
                document.body.classList.add('scrolled-header');
            }

            function update() {
                ticking = false;

                if (stickyType === 'none' || isMobileStickyDisabled()) {
                    setSticky(false);
                    return;
                }

                if (stickyType === 'always') {
                    if (!isSticky()) measure();
                    setSticky(true);
                    return;
                }

                if (stickyType === 'on_scroll') {
                    setSticky(getScrollTop() > triggerTop);
                }
            }

            function requestUpdate() {
                if (ticking) return;
                ticking = true;
                window.requestAnimationFrame(update);
            }

            function refresh() {
                measure();
                update();
            }

            measure();
            update();

            window.addEventListener('scroll', requestUpdate, { passive: true });
            window.addEventListener('resize', refresh);

            if (mobileStickyMedia.addEventListener) {
                mobileStickyMedia.addEventListener('change', refresh);
            } else if (mobileStickyMedia.addListener) {
                mobileStickyMedia.addListener(refresh);
            }

            if (window.ResizeObserver) {
                var resizeObserver = new ResizeObserver(function () {
                    if (isMobileStickyDisabled()) {
                        setSticky(false);
                        measure();
                        return;
                    }

                    if (isSticky()) {
                        headerHeight = wrapper.offsetHeight || headerHeight;
                        placeholder.style.height = headerHeight + 'px';
                        document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
                    } else {
                        refresh();
                    }
                });
                resizeObserver.observe(wrapper);
            }
        });
    }

    initStickyHeader(document);

    document.addEventListener('DOMContentLoaded', function () {
        initStickyHeader(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
        initStickyHeader(event.target);
    });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-multi-site"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-multi-site');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);
              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    document.addEventListener('DOMContentLoaded', () => {customElements.define('sticky-header', StickyHeader)});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-basic"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-basic');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-compact"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-compact');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-full-elements"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-full-elements');
if (sticky != undefined || sticky != null) {

    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-hamburger"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-hamburger');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('load', this.checkLoadPosition.bind(this));
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }
        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }
        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('load', this.checkLoadPosition);
          window.removeEventListener('scroll', this.onScrollHandler);
        }
        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }
        checkLoadPosition() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const headerGr = document.querySelectorAll(".shopify-section-group-header-group");

            if(headerGr[0].classList.contains('shopify-section-header-sticky')) {
                if(scrollTop > headerGr[0].offsetHeight && !this.header.classList.contains('scrolled-past-header')) {
                    this.header.classList.add('shopify-section-header-hidden');
                }
            } else {
                headerGr.forEach(item => {
                    if(item.classList.contains('shopify-section-header-sticky') ) {
                        const itemPrev = item.previousElementSibling;
                        const itemPrevHeight = itemPrev.offsetHeight;
                        const itemPrevTop = itemPrev.offsetTop;

                        if(scrollTop > itemPrevTop + itemPrevHeight && !this.header.classList.contains('scrolled-past-header')) {
                            this.header.classList.add('shopify-section-header-hidden');
                        }
                    }
                });
            }
        }
        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }
        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                    document.querySelector('body').classList.add("section-header-is-hidden")
                }
            }
          this.closeMenuDisclosure();
        }
        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
                  document.querySelector('body').classList.remove("section-header-is-hidden")
              }
            }
        }
        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
                  document.querySelector('body').classList.remove("section-header-is-hidden")
              }
            }
        }
        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-haozzha"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-plain');

if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('scrolled-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('scrolled-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        document.body.classList.remove('scrolled-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-left-aligned"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-left-aligned');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-plain"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-plain');

if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('scrolled-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('scrolled-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        document.body.classList.remove('scrolled-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-utility"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-utility');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-vertical-menu"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-vertical-menu');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
                if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                    $('.vertical-menu').addClass('vertical-menu__hide');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
              if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                  if (document.body.classList.contains('template-index')) {
                      if ($('.vertical-menu').hasClass('vertical-menu__hide')) {
                          $('.vertical-menu').removeClass('vertical-menu__hide');
                      }
                  }
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navigation-glass-wave"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-plain');

if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('scrolled-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('scrolled-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        document.body.classList.remove('scrolled-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();
})();
